import { render } from "./AdminReferenceDataView.vue?vue&type=template&id=09d7fcd8&scoped=true&ts=true"
import script from "./AdminReferenceDataView.vue?vue&type=script&lang=ts"
export * from "./AdminReferenceDataView.vue?vue&type=script&lang=ts"

import "./AdminReferenceDataView.vue?vue&type=style&index=0&id=09d7fcd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d7fcd8"]])

export default __exports__